(function() {
	'use strict';

	angular.module('claimsApp').controller('ClaimAdjustInfoGamController',
			ClaimAdjustInfoGamController);

	ClaimAdjustInfoGamController.$inject = [ '$scope', '$state', '$log','$resource','NgTableParams','Upload','authExpiredInterceptor','$timeout','$base64','ClaimAdjustInfo','CLAIM_TYPE','$filter','FORMAT_DATE','$window','GLOBAL_URL','ClaimRegistration','$stateParams','MyTask','$uibModal','FileNetService' ];

	function ClaimAdjustInfoGamController($scope, $state, $log, $resource,NgTableParams,Upload,authExpiredInterceptor,$timeout,$base64,ClaimAdjustInfo,CLAIM_TYPE,$filter,FORMAT_DATE,$window,GLOBAL_URL,ClaimRegistration,$stateParams,MyTask,$uibModal,FileNetService) {
		
		$scope.CLAIM_TYPE = CLAIM_TYPE;
		// init all data
		var param = $stateParams;
		
		var claimAdjustInfoGamCtr = this;
		claimAdjustInfoGamCtr.policyIsTPDAndRO1 = false;
		claimAdjustInfoGamCtr.claimCase  = {
			
		};
		
		claimAdjustInfoGamCtr.disableAll = false;
		
		claimAdjustInfoGamCtr.pendingNoticeGroupValid = [];
		claimAdjustInfoGamCtr.pendingNoticeGroupInvalid = [];
		
		
		claimAdjustInfoGamCtr.datePickerOpenStatus = {};
		
		claimAdjustInfoGamCtr.init = function() {
			var txnId = $base64.decode(param.txnId);
			var taskInstanceId = $base64.decode(param.taskId);
			
			
			ClaimAdjustInfo.loadAdjustInfo({txnId:txnId,taskInstanceId:taskInstanceId},function(result){
				claimAdjustInfoGamCtr.claimCase = result;
				claimAdjustInfoGamCtr.claimCase.taskInstanceId = taskInstanceId;
				
				if(result.claimType == 'TPD' && result.poType == 'RO1') {
					claimAdjustInfoGamCtr.policyIsTPDAndRO1 = true;
				}
				
				if(claimAdjustInfoGamCtr.claimCase.cancelled) {
					claimAdjustInfoGamCtr.disableAll = true;
				}
				
				claimAdjustInfoGamCtr.originalDocList = claimAdjustInfoGamCtr.claimCase.docList;
				angular.forEach(claimAdjustInfoGamCtr.claimCase.requestLetterList, function(requestLetter) {
					  if(requestLetter.valid!=null&&requestLetter.valid) {
						  claimAdjustInfoGamCtr.pendingNoticeGroupValid[requestLetter.pendingNoticeId] =true;
					  }
					  if(requestLetter.valid!=null&&!requestLetter.valid){
						  claimAdjustInfoGamCtr.pendingNoticeGroupInvalid[requestLetter.pendingNoticeId] = true;
						  requestLetter.invalid = true;
					  }
					});
				claimAdjustInfoGamCtr.requestLtrParams = new NgTableParams({
					page: 1,
					count: 100000000,
					 group: 'pendingNoticeId'
				},
				{
					total: 0,
					counts : [],
					defaultSort: 'desc',
					dataset : claimAdjustInfoGamCtr.claimCase.requestLetterList      	
				});
				claimAdjustInfoGamCtr.docParams = new NgTableParams({
					count : 100000000
				}, {
					 counts : [],
					 dataset: angular.copy(claimAdjustInfoGamCtr.originalDocList)
				});
				
				ClaimRegistration.getDocumentByType({claimType:claimAdjustInfoGamCtr.claimCase.claimType},function(result){
					claimAdjustInfoGamCtr.documents = result;
				})
				
				claimAdjustInfoGamCtr.claimCase.registerDateStr = $filter('date')(claimAdjustInfoGamCtr.claimCase.registerDate, FORMAT_DATE);
				
				claimAdjustInfoGamCtr.claimCase.docCompletedDateStr = $filter('date')(claimAdjustInfoGamCtr.claimCase.docCompletedDate, FORMAT_DATE);
				
				claimAdjustInfoGamCtr.claimCase.eventDateStr = $filter('date')(claimAdjustInfoGamCtr.claimCase.eventDate, FORMAT_DATE);
				
				claimAdjustInfoGamCtr.claimCase.hopitalStartDateStr = $filter('date')(claimAdjustInfoGamCtr.claimCase.hopitalStartDate, FORMAT_DATE);
				
				claimAdjustInfoGamCtr.claimCase.hopitalEndDateStr = $filter('date')(claimAdjustInfoGamCtr.claimCase.hopitalEndDate, FORMAT_DATE);
			});
		}
		
		
		// checkSignature from kofax
		claimAdjustInfoGamCtr.checkSignature = function (policyNum){
			if (policyNum == undefined || policyNum == null) return false;
			var policyNumArray = policyNum.split(',');
			FileNetService.query({method:'get-list-poldoc-by-policylist',policyList :policyNumArray}, function(result){
				if(result.length >0){
					claimAdjustInfoGamCtr.animationsEnabled = true;
					var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : claimAdjustInfoGamCtr.animationsEnabled,
						templateUrl : GLOBAL_URL+'partial?uri=ga/signature/signature-dialog',
						controller : 'SignatureDialogController as signatureDlgCtrl',
						size : 'lg',
						resolve : {
							items : function() {
								return result;//tranfer data for dialog
							}
						}
					});
					modalInstance.result.then(
					function(result) {
					},
					function(error){
					});
				}else{
					$scope.addAlert('File chữ ký PO không tồn tại.Vui lòng kiểm tra lại','warning');
				}
    		},
    		function(error){
    		});
		}

		//claimAdjustInfoGamCtr.init();
		
		claimAdjustInfoGamCtr.openCalendar1 = function(row) {
			row.isOpen = true;
		}
		
		claimAdjustInfoGamCtr.submit =function(){
			var data = [];
			claimAdjustInfoGamCtr.disableAll = true;
			
			claimAdjustInfoGamCtr.claimCase.docList = claimAdjustInfoGamCtr.originalDocList;
			if(claimAdjustInfoGamCtr.form.file.$valid &&claimAdjustInfoGamCtr.attachment){
				data['file'] = claimAdjustInfoGamCtr.attachment;
			}
			if (claimAdjustInfoGamCtr.form.file.$valid) {
				var json = JSON.stringify(claimAdjustInfoGamCtr.claimCase);
				$log.debug(json);
				data['claimAdjustInfoDto'] = new Blob([json], {type: "application/json"});
			 }
			
			 Upload.upload({
		            url: GLOBAL_URL + 'api/ga/claims/adjust-info/do-submit-adjust-gam?access_token=' + authExpiredInterceptor.getToken(),
		            data: data
		        }).then(function (resp) {
		            //$log.debug('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
		            claimAdjustInfoGamCtr.disableAll = true;
		            //open download ack letter
		            $timeout(function(){
		            	$window.open(GLOBAL_URL +"ga/claims/gen-adjust-info-ack-letter/"+$base64.encode(resp.data.claimAdjustInfoId)+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
		            },3000);
		        }, function (resp) {
		        	$log.debug('Error status: ' + resp.status);
		        	claimAdjustInfoGamCtr.disableAll = false;
		        }, function (evt) {
		        });		
		}
		claimAdjustInfoGamCtr.changeValidAll = function(pendingNoticeId){
			var pn = _.each(_.filter(claimAdjustInfoGamCtr.requestLtrParams.settings().dataset, function(value){ return value.pendingNoticeId == pendingNoticeId;}),function(requestLtr){
				if(requestLtr.valid) {
					requestLtr.valid = null;
					
				}
				else {
					if(requestLtr.invalid) {
						requestLtr.invalid = null;
						claimAdjustInfoGamCtr.pendingNoticeGroupInValid[pendingNoticeId] = null;
					}
					requestLtr.valid = true;
				}
				
			});
			
			
		}
		claimAdjustInfoGamCtr.changeInvalidAll = function(pendingNoticeId){
			var pn = _.each(_.filter(claimAdjustInfoGamCtr.requestLtrParams.settings().dataset, function(value){ return value.pendingNoticeId == pendingNoticeId;}),function(requestLtr){
				if(requestLtr.invalid) {
					requestLtr.invalid = null;
				}
				else {
					if(requestLtr.valid) {
						requestLtr.valid = null;
						claimAdjustInfoGamCtr.pendingNoticeGroupValid[pendingNoticeId] = null;
					}
					requestLtr.invalid = true;
				}
				
			});
		}
		claimAdjustInfoGamCtr.changeInvalid = function(requestLtr){
			if(requestLtr.invalid) requestLtr.valid = null;
			else requestLtr.valid = true;
		}
		
		claimAdjustInfoGamCtr.changeDoc = function(row){
			if(!row.documentCode) {
				row.documentName = '';
				return;
			}
			angular.forEach(claimAdjustInfoGamCtr.documents,function(doc){
				if(doc.documentCode ==row.documentCode) {
					row.documentName = doc.documentName;
				}
			})
		}
		
		claimAdjustInfoGamCtr.agentInfo = function (){
			if(claimAdjustInfoGamCtr.claimCase&&claimAdjustInfoGamCtr.claimCase.agentCode&&claimAdjustInfoGamCtr.claimCase.agentName) {
				return claimAdjustInfoGamCtr.claimCase.agentCode + " - "+ claimAdjustInfoGamCtr.claimCase.agentName;
			}
		}
		claimAdjustInfoGamCtr.surgery = function(){
			if(claimAdjustInfoGamCtr.claimCase&&claimAdjustInfoGamCtr.claimCase.surgeryCode&&claimAdjustInfoGamCtr.claimCase.surgeryName) {
				return claimAdjustInfoGamCtr.claimCase.surgeryCode + " - "+ claimAdjustInfoGamCtr.claimCase.surgeryName;
			}
		}
		
		claimAdjustInfoGamCtr.viewLetter = function(letterFileLogId){
			$window.open(GLOBAL_URL+'ga/claims/request-letter/download/'+$base64.encode(letterFileLogId)+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
		}
		
		claimAdjustInfoGamCtr.cancel = function(){
			var modalInstance = 
				//show dialog
				$uibModal.open({
					templateUrl : GLOBAL_URL+'partial?uri=ga/claims/adjust-info/claim-adjust-info-gam-cancel-dialog',
					controller : 'ClaimAdjustInfoGAMCancelDialogController as claimAdjustInfoCancelTaskCtr',
					size : 'lg',
					resolve : {
						claimCase : claimAdjustInfoGamCtr.claimCase
					}
			});
			modalInstance.result.then(
					function(result) {
						claimAdjustInfoGamCtr.disableAll= true;
					},
					function(error){
						
					});
		}
				
		claimAdjustInfoGamCtr.resetForm = function(){
			$state.transitionTo($state.current, {}, { 
	  			  reload: true, inherit: false, notify: true
	  		});
		}
		
		claimAdjustInfoGamCtr.requestLtrParams = new NgTableParams({
			count : 100000000
		},
		{
			total: 0,
			counts: [],
			defaultSort: 'desc',
			dataset : angular.copy(claimAdjustInfoGamCtr.claimCase.requestLetterList)       	
		});
		
		
		claimAdjustInfoGamCtr.returnTask = function(){
			if(claimAdjustInfoGamCtr.claimCase.taskInstanceId){
				var uri = 'task/#/my-task';
				MyTask.release({
					taskId : claimAdjustInfoGamCtr.claimCase.taskInstanceId
				}, function(result) {
					$window.open(GLOBAL_URL + uri, '_self')
				})
			}
		}

		claimAdjustInfoGamCtr.deleteCount = 0;

		claimAdjustInfoGamCtr.documents = [];
		claimAdjustInfoGamCtr.docList = [];

		claimAdjustInfoGamCtr.originalDocList = angular.copy(claimAdjustInfoGamCtr.docList);

		
		claimAdjustInfoGamCtr.docParams = new NgTableParams({
			count : 100000000
		}, {
			 counts :[],
			 dataset: angular.copy(claimAdjustInfoGamCtr.originalDocList)
		});
		
		
		claimAdjustInfoGamCtr.add = function() {
		      claimAdjustInfoGamCtr.isEditing = true;
		      claimAdjustInfoGamCtr.isAdding = true;
		      claimAdjustInfoGamCtr.docParams.settings().dataset.unshift({doc:{},no:1,receivedDate:new Date(),remark:'',invalid:false});
		      // we need to ensure the user sees the new row we've just added.
		      // it seems a poor but reliable choice to remove sorting and move them to the first page
		      // where we know that our new item was added to
		      claimAdjustInfoGamCtr.docParams.sorting({});
		      claimAdjustInfoGamCtr.docParams.page(1);
		      claimAdjustInfoGamCtr.docParams.reload();
		}

		claimAdjustInfoGamCtr.cancelChanges = function() {
		      claimAdjustInfoGamCtr.resetTableStatus();
		      var currentPage = claimAdjustInfoGamCtr.docParams.page();
		      claimAdjustInfoGamCtr.docParams.settings({
		        dataset: angular.copy(claimAdjustInfoGamCtr.originalDocList)
		      });
		      // keep the user on the current page when we can
		      if (!claimAdjustInfoGamCtr.isAdding) {
		        claimAdjustInfoGamCtr.docParams.page(currentPage);
		      }
		    }

		claimAdjustInfoGamCtr.del = function(row) {
		      _.remove(claimAdjustInfoGamCtr.docParams.settings().dataset, function(item) {
		        return row === item;
		      });
		      claimAdjustInfoGamCtr.deleteCount++;
		      claimAdjustInfoGamCtr.tableTracker.untrack(row);
		      claimAdjustInfoGamCtr.docParams.reload().then(function(data) {
		        if (data.length === 0 && claimAdjustInfoGamCtr.docParams.total() > 0) {
		          claimAdjustInfoGamCtr.docParams.page(claimAdjustInfoGamCtr.docParams.page() - 1);
		          claimAdjustInfoGamCtr.docParams.reload();
		        }
		      });
		 }

		claimAdjustInfoGamCtr.hasChanges = function() {
		      return claimAdjustInfoGamCtr.tableForm.$dirty || claimAdjustInfoGamCtr.deleteCount > 0;
		 }

		claimAdjustInfoGamCtr.resetTableStatus = function() {
		      claimAdjustInfoGamCtr.isEditing = false;
		      claimAdjustInfoGamCtr.isAdding = false;
		      claimAdjustInfoGamCtr.deleteCount = 0;
		      claimAdjustInfoGamCtr.tableTracker.reset();
		      claimAdjustInfoGamCtr.tableForm.$setPristine();
		    }

		claimAdjustInfoGamCtr.saveChanges = function() {
	      claimAdjustInfoGamCtr.resetTableStatus();
	      var currentPage = claimAdjustInfoGamCtr.docParams.page();
	      claimAdjustInfoGamCtr.originalDocList = angular.copy(claimAdjustInfoGamCtr.docParams.settings().dataset);
	    }

	}
})();
